import { useEffect } from 'react';

import { startAuthorizeRedirect } from '@/app/router/authorizeRedirect';

// Shim for the pre-extraction local auth routes (/login, /signup,
// /forgot-password, /reset-password, /verify-email). Authentication lives
// entirely on the central signcare-auth hosted pages now (email+password,
// Google Sign-In, signup, password reset, email verification) — old bookmarks
// and deep links land here and are forwarded into the same authorize flow
// ProtectedRoute uses. See google-sign-in-plan GS1 + auth-extraction-cleanup.
export function LegacyAuthRedirect() {
  useEffect(() => {
    startAuthorizeRedirect();
  }, []);

  return (
    <div className="flex min-h-dvh items-center justify-center">
      <p className="text-sm text-muted-foreground">Redirecting to SignCare sign-in…</p>
    </div>
  );
}
